/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/no-unnamed-components */
/* eslint-disable no-unused-vars */

'use es6';

import { useTheme } from 'foundations-theming/utils';
import CsatButton from './internal/CsatButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const path = 'M416 0Q303 0 206 57q-94 55-149 149Q0 303 0 416t57 210q55 94 149 150 97 56 210 56t210-56q94-56 149-150 57-97 57-210t-57-210q-55-94-149-149Q529 0 416 0zm145 290q18 0 32 10t21 26q4 11 4 22 0 24-17 41t-40 17q-12 0-23-4h1q-16-7-26-21.5T503 349q0-24 17-41t41-18zm-290 0q24 0 41 17t17 41-17 41-41 17q-13 0-24-4h1q-16-7-25.5-21.5T213 349q0-24 16.5-41t40.5-18h1zm-9 264h308q13 0 22.5 9.5T602 586t-9.5 22.5T570 618H262q-13 0-22.5-9.5T230 586t9.5-22.5T262 554z';
export default (props => {
  const trellisTheme = useTheme();
  return /*#__PURE__*/_jsx(CsatButton, Object.assign({
    color: trellisTheme.color['do-not-use-chart-orange'],
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "feedback-shared.ratings.neutral"
    })
  }, props, {
    children: /*#__PURE__*/_jsx("g", {
      id: "Setup---Choose-Survey---CSAT---Chat",
      transform: "translate(-958.000000, -762.000000)",
      fillRule: "nonzero",
      children: /*#__PURE__*/_jsx("g", {
        id: "chat-widget",
        transform: "translate(761.000000, 320.000000)",
        children: /*#__PURE__*/_jsxs("g", {
          id: "Neutral",
          transform: "translate(198.000000, 443.000000)",
          children: [/*#__PURE__*/_jsx("path", {
            d: "M26,0 C11.6405965,0 0,11.6405965 0,26 C0,40.3594035 11.6405965,52 26,52 C40.3594035,52 52,40.3594035 52,26 C51.9787869,11.6493924 40.3506076,0.0212130541 26,0 Z",
            id: "Path",
            stroke: "#33475C",
            strokeWidth: "2",
            fill: "#FDCABD"
          }), /*#__PURE__*/_jsx("path", {
            d: "M35.0518519,18.1422222 C36.5085151,18.1422222 37.821746,19.019695 38.3791869,20.3654764 C38.9366278,21.7112578 38.6285003,23.2603192 37.5984838,24.2903357 C36.5684673,25.3203522 35.019406,25.6284796 33.6736246,25.0710387 C32.3278432,24.5135978 31.4503704,23.200367 31.4503704,21.7437037 C31.4503704,19.7546604 33.0628086,18.1422222 35.0518519,18.1422222 L35.0518519,18.1422222 Z",
            id: "Path",
            fill: "#33475C"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.9481481,18.1422222 C18.4048114,18.1422222 19.7180423,19.019695 20.2754832,20.3654764 C20.8329241,21.7112578 20.5247966,23.2603192 19.4947801,24.2903357 C18.4647636,25.3203522 16.9157022,25.6284796 15.5699209,25.0710387 C14.2241395,24.5135978 13.3466667,23.200367 13.3466667,21.7437037 C13.3466667,19.7546604 14.9591048,18.1422222 16.9481481,18.1422222 Z",
            id: "Path",
            fill: "#33475C"
          }), /*#__PURE__*/_jsx("rect", {
            id: "Path",
            fill: "#33475C",
            x: "14.4444444",
            y: "34.4162963",
            width: "23.1111111",
            height: "3.85185185",
            rx: "1.92592593"
          })]
        })
      })
    })
  }));
});